import { notification, Select, Modal, Spin, Button, Progress, Dropdown, Tooltip } from "antd";
import React, { useEffect, useState, useRef, useCallback } from "react";
import { useAuth } from '../../component/auth/AuthContext';
import { useUpload } from '../../component/main/history/UploadContext';
import {
  deleteSosReport,
  getSosReport,
  updateSosReport,
} from "../../store/history/action";
import { ListOptionSize, URL } from "../../utils/contact";
import { forbiddenFromResponse, isForbidden } from "../../services/base.service";
import ModalDelete from "./component/Modal/ModalDelete";
import ModalSearch from "./component/Modal/ModalSearch";
import TableHistory from "./component/table/TableHistory";
import "./HistoryStyled.scss";
import { getCancelUpload } from "../../store/upload/action";
import {
  AppstoreFilled,
  SearchOutlined,
  CloseOutlined,
  UnorderedListOutlined,
  BorderVerticleOutlined,
  BorderHorizontalOutlined
} from '@ant-design/icons';
import 'react-resizable/css/styles.css';
import styles from './HV.module.scss';
import { Trans, useTranslation } from 'react-i18next';

const History = () => {
  const { t } = useTranslation();

  const { getUser } = useAuth();
  
  // const [contextHolder] = notification.useNotification();
  const [openModal, setOpenModal] = useState(false);
  const [showDeleteItem, setShowDeleteItem] = useState(false);
  const [tableParams, setTableParams] = useState({
    pageNumber: 1,
    pageSize: 30,
    search: {},
    username: getUser()?.data?.username || "",
  });
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalPages, setTotalPages] = useState("");
  const { uploadComplete } = useUpload();
  const [pageLoading, setPageLoading] = useState(true);
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [totalProgress, setTotalProgress] = useState(0);
  const [layoutType, setLayoutType] = useState('default');
  
  const username = getUser()?.data?.username || "";

  const MAX_FILE_SIZE_MB = 200;
  const ALLOWED_EXTENSIONS = [".tar.xz", ".tar.gz", ".tar.bz2", ".tar"];
  const MAX_FILE_COUNT = 5;

  const [guidValue, setGuidValue] = useState("");
  const eventSourceRef = useRef(null);
  const isCancelledRef = useRef(false);
  // eslint-disable-next-line no-unused-vars
  const [fileProgresses, setFileProgresses] = useState({});

  // 리사이즈 관련 상태 및 참조
  const [isResizing, setIsResizing] = useState(false);
  const splitViewRef = useRef(null);
  const mainContentRef = useRef(null);
  
  //pagination
  const onChangeLimitPage = (value) => {
    setTableParams({
      ...tableParams,
      pageSize: value,
      pageNumber: 1
    });
  };

  const onChangePage = (paginate, _, sort) => {
    const sortBy = {
      sortBy: sort.order === undefined ? "" : sort.field,
      type: sort.order === undefined ? "" : sort.order,
    };
    setTableParams({
      ...tableParams,
      pageNumber: paginate.current,
      sortBy,
    });
    getTableHistory({
      ...tableParams,
      pageNumber: paginate.current,
      sortBy,
    });
  };

  //onselect item
  const onSelectChange = (selectedRowKeys, selectedRows) => {
    setSelectedRows(selectedRows);
    setSelectedRowKeys(selectedRowKeys);
  };

  //handle search
  const onChangeSearch = (search) => {
    getTableHistory({ ...tableParams, search });
  };

  //api getlist
  const getTableHistory = async (payload) => {
    try {
      const response = await getSosReport(payload);
      if (response) {
        setTotalPages(response?.totalElements || 0);
        const contentData = response?.content;
        setData(Array.isArray(contentData) ? contentData : []);
      }
    } catch (error) {
      console.error(t('history.notify.fetchFailed'), error);
    } finally {
      setLoading(false);
      setPageLoading(false);
    }
  };

  //changeName
  const handleChangeName = async (payload) => {
    const response = await updateSosReport(payload);
    if (response) {
      openNotificationWithIcon('success', t('history.notify.renamed'));
      getTableHistory(tableParams);
    }
  };

  //delete
  const handleDeleteItem = async (dataTable) => {
    // console.log("handleDeleteItem dataTable ["+JSON.stringify(dataTable)+"]");
    
    // eslint-disable-next-line no-unused-vars
    // let report_owner = "";
    setIsLoading(true);
    try {
      await new Promise(resolve => setTimeout(resolve, 300));
      const payload = dataTable.map((ele) => {
        // report_owner = ele.username;
        return ele.id;
      });
      // console.log("username ["+username+"]");
      // console.log("report_owner ["+report_owner+"]");
      // console.log("handleDeleteItem payload ["+JSON.stringify(payload)+"]");
      const response = await deleteSosReport(payload, username);
      if (response) {
        setShowDeleteItem(false);
        getTableHistory(tableParams);
        setSelectedRowKeys([]);
        setSelectedRows([]);
      }
    } catch (error) {
      notification.error({
        message: t('history.notify.deleteFailedTitle'),
        description: t('history.notify.deleteFailedDesc'),
        placement: 'top',
        duration: 3,
      });
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 400);
    }
  };

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: type === 'success' ? t('history.notify.success') : 
               type === 'error' ? t('history.notify.error') : 
               type === 'warning' ? t('history.notify.warning') : t('history.notify.info'),
      description: message,
      placement: 'top',
      duration: 3,
    });
  };

  const handleFilesUpload = (files) => {
    const fileArray = Array.from(files);
    
    // 파일명에 특수문자나 공백이 있는지 확인
    const invalidNameFiles = fileArray.filter(file => {
      // 영문자, 숫자와 허용되는 특수문자만 체크: (), [], {}, =, 공백, -, 한글
      const validNamePattern = /^[a-zA-Z0-9.()[\]{}=\- 가-힣]+$/;
      return !validNamePattern.test(file.name.split('.')[0]); // 확장자 제외한 파일명만 검사
    });
    
    if (invalidNameFiles.length > 0) {
      notification.error({
        message: t('history.notify.invalidNameTitle'),
        description: t('history.notify.invalidNameDesc', { files: invalidNameFiles.map(file => file.name).join(', ') }),
        placement: "top",
      });
      return;
    }
    
    // Check file format
    const invalidFiles = fileArray.filter(file => {
      return !ALLOWED_EXTENSIONS.some(extension => file.name.toLowerCase().endsWith(extension));
    });

    if (invalidFiles.length > 0) {
      notification.error({
        message: t('history.notify.invalidTypeTitle'),
        description: t('history.notify.invalidTypeDesc', { files: invalidFiles.map(file => file.name).join(', ') }),
        placement: "top",
      });
      return;
    }

    // Check file size
    const oversizedFiles = fileArray.filter(file => file.size > MAX_FILE_SIZE_MB * 1024 * 1024);
    if (oversizedFiles.length > 0) {
      notification.error({
        message: t('history.notify.oversizeTitle'),
        description: t('history.notify.oversizeDesc', { files: oversizedFiles.map(file => file.name).join(', ') }),
        placement: "top",
      });
      return;
    }

    handleUpload(fileArray);
  };

  const handleFileSelect = () => {
    // console.log("handleFileSelect called");
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    // console.log("handleFileChange called");
    const files = Array.from(e.target.files);
    // console.log("Files selected:", files.length);
    
    // 파일 개수 제한 확인 (5개)
    // if (files.length > 5) {
    //   notification.error({
    //     message: t('history.notify.tooManyTitle'),
    //     description: t('history.notify.tooManyDesc', { selected: files.length }),
    //     placement: "top",
    //   });
    //   // 파일 선택 초기화
    //   e.target.value = '';
    //   return;
    // }
    
    // 파일명에 허용되지 않는 특수문자가 있는지 확인
    const invalidNameFiles = files.filter(file => {
      // 영문자, 숫자와 허용되는 특수문자만 체크: (), [], {}, =, 공백, -, 한글
      const validNamePattern = /^[a-zA-Z0-9.()[\]{}=\- 가-힣]+$/;
      return !validNamePattern.test(file.name.split('.')[0]); // 확장자 제외한 파일명만 검사
    });
    
    if (invalidNameFiles.length > 0) {
      notification.error({
        message: t('history.notify.invalidNameTitle'),
        description: t('history.notify.invalidNameDesc', { files: invalidNameFiles.map(file => file.name).join(', ') }),
        placement: "top",
      });
      // 파일 선택 초기화
      e.target.value = '';
      return;
    }
    
    handleFilesUpload(files);
  };

  const handleDragEnter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggingOver(true);
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggingOver(true);
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDraggingOver(false);
  };

  const handleDrop = (e) => {
    // console.log("handleDrop called");
    e.preventDefault();
    e.stopPropagation();
    setIsDraggingOver(false);
    const files = Array.from(e.dataTransfer.files);
    // console.log("Files dropped:", files.length);
    
    // 파일 개수 제한 확인 (5개)
    if (files.length > MAX_FILE_COUNT) {
      notification.error({
        message: t('history.notify.tooManyTitle'),
        description: t('history.notify.tooManyDesc', { selected: files.length }),
        placement: "top",
      });
      return;
    }
    
    handleFilesUpload(files);
  };

  const handleUpload = async (files) => {
    if (!files.length) return;
    
    await new Promise(resolve => {
      resetUploadState();
      setTimeout(resolve, 100);
    });
    
    setIsUploading(true);
    isCancelledRef.current = false;
    const totalFiles = files.length;
    let abortController = new AbortController();
    
    setFileProgresses({});

    const uploadPromises = files.map((file, index) => {
      return new Promise((resolve, reject) => {
        const data = new FormData();
        data.append("file", file);
        data.append("username", username);

        const eventSource = new EventSource(`${URL}/api/file/progress`);
        eventSourceRef.current = eventSource;
        
        eventSource.addEventListener("GUI_ID", async (event) => {
          const guid = JSON.parse(event.data);
          setGuidValue(prev => prev ? `${prev},${guid}` : guid);
          data.append("guid", guid);

          eventSource.addEventListener(guid, (event) => {
            if (isCancelledRef.current) {
              eventSource.close();
              resolve({ cancelled: true });
              return;
            }

            try {
              const result = JSON.parse(event.data);
              
              if (result === 'error' || result === 'duplicate') {
                eventSource.close();
                reject(new Error(result));
                return;
              }

              if (result <= 100) {
                setFileProgresses(prev => {
                  const newProgresses = { ...prev, [index]: result };
                  const totalProgress = Object.values(newProgresses).reduce((sum, progress) => sum + progress, 0) / totalFiles;
                  setTotalProgress(Math.min(Math.round(totalProgress), 100));
                  return newProgresses;
                });
                
                if (result === 100) {
                  eventSource.close();
                  resolve({ success: true });
                }
              }
              if (result?.id) {
                eventSource.close();
                resolve({ success: true });
              }
            } catch (error) {
              eventSource.close();
              reject(error);
            }
          });

          try {
            await uploadToServer(`${URL}/api/file/upload`, data, abortController.signal);
          } catch (error) {
            eventSource.close();
            if (error.status === 409) {
              // Cancel upload if duplicate file is found
              isCancelledRef.current = true;
              abortController.abort();
              notification.error({
                message: t('history.notify.duplicateTitle'),
                description: t('history.notify.duplicateDesc'),
                placement: 'top',
                key: 'upload-error'
              });
              handleCancel(); // Cancel all ongoing uploads
            }
            reject(error);
          }
        });

        eventSource.onerror = () => {
          eventSource.close();
          reject(new Error("EventSource failed"));
        };
      });
    });

    try {
      const results = await Promise.all(uploadPromises);
      
      if (results.some(result => result?.cancelled) || isCancelledRef.current) {
        notification.info({
          message: t('history.notify.cancelTitle'),
          description: t('history.notify.cancelDesc'),
          placement: 'top',
          key: 'upload-cancel'
        });
        refreshHistory();
        resetUploadState();
        return;
      }

      setTotalProgress(100);
      notification.success({
        message: t('history.notify.uploadDoneTitle'),
        description: t('history.notify.uploadDoneDesc'),
        placement: 'top',
        key: 'upload-success'
      });
      refreshHistory();
      resetUploadState();

    } catch (error) {
      // 403 은 forbiddenFromResponse 가 이미 안내했으므로 겹쳐 띄우지 않습니다.
      if (!isCancelledRef.current && !isForbidden(error)) {
        notification.error({
          message: t('history.notify.uploadFailTitle'),
          description: t('history.notify.uploadFailDesc'),
          placement: 'top',
          key: 'upload-error'
        });
      }
      refreshHistory();
      resetUploadState();
    }
  };

  const handleCancel = async () => {
    if (!guidValue || isCancelledRef.current) return;

    // 즉시 취소 상태로 설정
    isCancelledRef.current = true;
    
    // 취소 중임을 표시하는 로딩 상태 추가
    setIsUploading(true); // 업로드 상태 유지 (UI 변경 방지)
    
    // 모든 EventSource 연결 즉시 종료
    if (eventSourceRef.current) {
      eventSourceRef.current.close();
      eventSourceRef.current = null;
    }

    // 취소 알림은 한 번만 표시
    notification.info({
      message: t('history.notify.cancelTitle'),
      description: t('history.notify.cancelingDesc'),
      placement: 'top',
      key: 'upload-cancel',
      duration: 2
    });

    try {
      const guids = guidValue.split(',');
      
      // 취소 요청에 타임아웃 추가
      const cancelPromises = guids.map(guid => {
        // 각 취소 요청에 30초 타임아웃 설정
        const timeoutPromise = new Promise((_, reject) => 
          setTimeout(() => reject(new Error('Cancel request timeout')), 30000)
        );
        
        // 실제 취소 요청
        const cancelPromise = getCancelUpload({ guidValue: guid })
          .catch(error => {
            console.error(`Cancel error for guid ${guid}:`, error);
            throw error; // 에러를 다시 던져서 Promise.race에서 감지할 수 있게 함
          });
        
        // 둘 중 먼저 완료되는 것 반환
        return Promise.race([cancelPromise, timeoutPromise]);
      });
      
      // 모든 취소 요청 처리 대기
      await Promise.all(cancelPromises);
      
      // 취소 성공 메시지
      notification.success({
        message: t('history.notify.cancelDoneTitle'),
        description: t('history.notify.cancelDesc'),
        placement: 'top',
        key: 'upload-cancel-success'
      });
      
    } catch (error) {
      console.error("Error during cancellation:", error);
      
      // 취소 실패 시 사용자에게 알림
      notification.error({
        message: t('history.notify.cancelFailTitle'),
        description: t('history.notify.cancelFailDesc'),
        placement: 'top',
        key: 'upload-cancel-error',
        duration: 0, // 수동으로 닫을 때까지 유지
        btn: (
          <button 
            onClick={() => window.location.reload()} 
            style={{ padding: '4px 8px', cursor: 'pointer' }}
          >
            {t('history.notify.refresh')}
          </button>
        )
      });
    } finally {
      // 테이블 재조회
      refreshHistory();
      
      // 상태 초기화 전 약간의 지연
      setTimeout(() => {
        resetUploadState();
      }, 500);
    }
  };

  const resetUploadState = () => {
    setTotalProgress(0);
    setFileProgresses({});
    setGuidValue("");
    setIsUploading(false);
    isCancelledRef.current = false;
    if (eventSourceRef.current) {
      eventSourceRef.current.close();
      eventSourceRef.current = null;
    }
  };

  const refreshHistory = () => {
    getTableHistory(tableParams);
  };

  const uploadToServer = async (url, data, signal) => {
    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
        signal,
      });

      // 라이선스 차단(403)은 여기서 먼저 걸러 안내합니다. 아래 파싱은 정상 응답
      // 형식을 전제하므로, 403 본문이 들어오면 default 분기로 빠져 사용자가
      // "알 수 없는 오류" 만 보게 됩니다.
      const forbidden = await forbiddenFromResponse(response);
      if (forbidden) throw forbidden;

      const responseData = await response.json();

      if (responseData.status === 'CANCELLED') {
        return responseData;
      }

      switch(responseData.status) {
        case 'SUCCESS':
          return responseData;
        case 'DUPLICATE':
          const duplicateError = new Error(responseData.message || t('history.err.duplicate'));
          duplicateError.status = 409;
          throw duplicateError;
        case 'FAIL':
          const failError = new Error(responseData.message || t('history.err.uploadFailed'));
          failError.status = 400;
          throw failError;
        case 'ERROR':
          const serverError = new Error(responseData.message || t('history.err.server'));
          serverError.status = 500;
          throw serverError;
        default:
          const unknownError = new Error(t('history.err.unknown'));
          unknownError.status = 500;
          throw unknownError;
      }
    } catch (error) {
      throw error;
    }
  };

  // 리사이즈 핸들러 함수
  const handleResize = (e) => {
    e.preventDefault();
    
    if (!mainContentRef.current || !splitViewRef.current) {
      return;
    }
    
    setIsResizing(true);
    
    // 마우스 이동 핸들러
    const onMouseMove = (moveEvent) => {
      moveEvent.preventDefault(); // 드래그 중 텍스트 선택 방지
      
      if (layoutType === 'horizontal') {
        // 가로 모드일 때 (위아래 분할)
        const containerHeight = splitViewRef.current.clientHeight;
        const newHeight = ((moveEvent.clientY - splitViewRef.current.getBoundingClientRect().top) / containerHeight) * 100;
        const clampedHeight = Math.max(10, Math.min(90, newHeight));
        
        mainContentRef.current.setAttribute('style', 
          `height: ${clampedHeight}% !important; 
            width: 100% !important; 
            overflow: auto !important; 
            max-height: 100%;`
        );
      } else if (layoutType === 'vertical') {
        // 세로 모드일 때 (좌우 분할)
        const containerWidth = splitViewRef.current.clientWidth;
        const newWidth = ((moveEvent.clientX - splitViewRef.current.getBoundingClientRect().left) / containerWidth) * 100;
        const clampedWidth = Math.max(10, Math.min(90, newWidth));
        
        mainContentRef.current.setAttribute('style', 
          `width: ${clampedWidth}% !important; 
            height: 100% !important; 
            overflow: auto !important; 
            max-width: 100%;`
        );
      }
    };
    
    // 마우스 업 핸들러
    const onMouseUp = () => {
      document.removeEventListener('mousemove', onMouseMove);
      document.removeEventListener('mouseup', onMouseUp);
      setIsResizing(false);
    };
    
    // 이벤트 리스너 등록
    document.addEventListener('mousemove', onMouseMove);
    document.addEventListener('mouseup', onMouseUp);
  };

  // 데이터 수에 따라 가로 분할 비율 조정하는 함수를 useCallback으로 메모이제이션
  const adjustHorizontalSplit = useCallback(() => {
    if (!mainContentRef.current || !splitViewRef.current) return;
    
    if (data.length < 5) {
      // 5건 미만이면 테이블 영역 20%, 가로보기 80% (퍼센트 기준)
      mainContentRef.current.setAttribute('style', 
        `height: 20% !important; 
          width: 100% !important; 
          overflow: auto !important; 
          max-height: 100%;`
      );
    } else {
      // 5건 이상이면 브라우저 창 높이 기준 50:50 분할
      const windowHeight = window.innerHeight;
      const headerHeight = 120; // 헤더 영역 높이 (대략적인 값, 실제 측정 필요)
      const availableHeight = windowHeight - headerHeight;
      
      // 테이블 영역은 전체 가용 높이의 50%로 설정
      const tableHeight = Math.floor(availableHeight * 0.4);
      
      // 최소 높이 설정 (너무 작아지지 않도록)
      const minTableHeight = 200;
      const finalTableHeight = Math.max(tableHeight, minTableHeight);
      
      // 픽셀 단위로 높이 설정
      mainContentRef.current.setAttribute('style', 
        `height: ${finalTableHeight}px !important; 
          width: 100% !important; 
          overflow: auto !important; 
          max-height: 100%;`
      );
    }
    
    // console.log(`Data length: ${data.length}, Split mode: ${data.length < 5 ? '10:90' : '50:50'}`);
  }, [mainContentRef, splitViewRef, data.length]);

  // 창 크기 변경 이벤트 리스너 추가
  useEffect(() => {
    if (layoutType === 'horizontal') {
      // 초기 설정
      adjustHorizontalSplit();
      
      // 창 크기 변경 시 분할 비율 재조정
      const handleResize = () => {
        if (layoutType === 'horizontal') {
          adjustHorizontalSplit();
        }
      };
      
      window.addEventListener('resize', handleResize);
      
      // 클린업 함수
      return () => {
        window.removeEventListener('resize', handleResize);
      };
    }
  }, [layoutType, adjustHorizontalSplit]);

  // 리포트 클릭 핸들러도 adjustHorizontalSplit 의존성 추가
  const handleReportClick = useCallback((reportId) => {
    // 선택된 행 키 설정
    setSelectedRowKeys([reportId]);
    
    // 선택된 행 객체도 설정
    const selectedItem = data.find(item => item.id === reportId);
    if (selectedItem) {
      setSelectedRows([selectedItem]);
    }
    
    // 레이아웃이 기본값이면 가로 분할로 변경
    if (layoutType === 'default') {
      setLayoutType('horizontal');
      
      // 다음 렌더링 사이클에서 데이터 수에 따라 분할 비율 설정
      setTimeout(() => {
        adjustHorizontalSplit();
        
        // 선택한 행이 테이블 영역에 보이도록 스크롤 조정
        setTimeout(() => {
          // 선택된 행 요소 찾기
          const selectedRow = document.querySelector(`tr[data-row-key="${reportId}"]`);
          if (selectedRow && mainContentRef.current) {
            // 선택된 행의 위치 계산
            const rowRect = selectedRow.getBoundingClientRect();
            const containerRect = mainContentRef.current.getBoundingClientRect();
            
            // 행이 컨테이너 밖에 있는지 확인
            if (rowRect.bottom > containerRect.bottom || rowRect.top < containerRect.top) {
              // 행이 컨테이너 중앙에 오도록 스크롤 조정
              selectedRow.scrollIntoView({ block: 'center', behavior: 'smooth' });
            }
          }
        }, 100); // 레이아웃 변경 후 약간의 지연 시간을 두고 스크롤 조정
      }, 0);
    } else {
      // 이미 분할 모드인 경우에도 선택한 행이 보이도록 스크롤 조정
      setTimeout(() => {
        const selectedRow = document.querySelector(`tr[data-row-key="${reportId}"]`);
        if (selectedRow && mainContentRef.current) {
          selectedRow.scrollIntoView({ block: 'center', behavior: 'smooth' });
        }
      }, 50);
    }
  }, [layoutType, setSelectedRowKeys, setLayoutType, adjustHorizontalSplit, data]);

  useEffect(() => {
    let isMounted = true;

    const fetchData = async () => {
      try {
        // console.log('Browser Language:', navigator.language);
        if (isMounted) {
          await getTableHistory(tableParams);
        }
      } catch (error) {
        console.error('Error fetching table history:', error);
      }
    };

    fetchData();

    return () => {
      isMounted = false;
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tableParams, uploadComplete]);
  
  // 레이아웃 메뉴 아이템
  const layoutMenuItems = [
    {
      key: 'default',
      label: t('history.layout.default'),
      icon: <UnorderedListOutlined />,
      onClick: () => setLayoutType('default')
    },
    {
      key: 'horizontal',
      label: t('history.layout.horizontal'),
      icon: <BorderVerticleOutlined />,
      onClick: () => {
        setLayoutType('horizontal');
        // 레이아웃 타입 변경 후 다음 렌더링 사이클에서 분할 비율 조정
        setTimeout(() => {
          adjustHorizontalSplit();
        }, 0);
      }
    },
    {
      key: 'vertical',
      label: t('history.layout.vertical'),
      icon: <BorderHorizontalOutlined />,
      onClick: () => setLayoutType('vertical')
    }
  ];

  // 레이아웃 변경 시 초기 크기 설정
  useEffect(() => {
    if (!mainContentRef.current) return;
    
    if (layoutType === 'default') {
      // 기본 모드일 때는 처리하지 않음
      return;
    } else if (layoutType === 'horizontal') {
      // 가로 모드일 때는 상단 영역을 50%로 설정
      mainContentRef.current.style.height = '50%';
      mainContentRef.current.style.width = '100%';
    } else if (layoutType === 'vertical') {
      // 세로 모드일 때는 좌측 영역을 50%로 설정
      mainContentRef.current.style.width = '50%';
      mainContentRef.current.style.height = '100%';
    }
  }, [layoutType]);

  // 레이아웃 변경 시 스크롤 위치 조정
  useEffect(() => {
    if (layoutType === 'horizontal') {
      // 약간의 지연 후 스크롤을 맨 아래로 이동
      setTimeout(() => {
        const splitViewElement = splitViewRef.current;
        if (splitViewElement) {
          splitViewElement.scrollTop = splitViewElement.scrollHeight;
        }
      }, 100);
    }
  }, [layoutType]);

  return (
    <div 
      style={{ height: '100%', display: 'flex' }}
      className={isDraggingOver ? 'dragging-over' : ''}
      onDrop={handleDrop}
      onDragEnter={handleDragEnter}
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
    >
      <div className="wrapper-history" style={{ height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', width: '100%' }}>
        <div className="page-title p-16">{t('pageTitle.history')}</div>
        <div className="history-header p-16">
          <div className="left-section">
            <div className="wrapper-search">
              <div className="wrapper-search__container">
                <div className="wrapper-search__size">
                  <Select
                    style={{
                      width: 90,
                      height: 30,
                    }}
                    value={tableParams?.pageSize}
                    onChange={onChangeLimitPage}
                    options={ListOptionSize}
                  />
                  <div
                    className="wrapper-search__search"
                    onClick={() => setOpenModal(true)}
                  >
                    <SearchOutlined className="fz-20" />
                  </div>
                  <div className="navbar-upload">
                    <div 
                      className={`wrapper-upload-mini ${isDraggingOver ? 'active' : ''}`}
                      onClick={handleFileSelect}
                    >
                      <div className="wrapper-upload-mini__content">
                        <div className="wrapper-upload-mini__text">
                          Choose Or Drag & Drop
                        </div>
                      </div>
                    </div>
                    <input
                      type="file"
                      ref={fileInputRef}
                      onChange={(e) => {
                        if (e.target.files.length > MAX_FILE_COUNT) {
                          notification.error({
                            message: t('history.notify.tooManyTitle'),
                            description: t('history.notify.tooManyDesc', { selected: e.target.files.length }),
                            placement: "top",
                          });
                          // 파일 선택 초기화
                          e.target.value = '';
                          return;
                        }
                        
                        handleFileChange(e);
                      }}
                      style={{ display: 'none' }}
                      multiple
                    />
                    {isUploading && (
                      <div className="upload-progress">
                        <div className="upload-progress__header">
                          <div style={{ position: 'relative', width: '100%' }}>
                            <Progress 
                              percent={totalProgress}
                              status={totalProgress === 100 ? "success" : "active"}
                              format={() => ''}
                              strokeColor={{
                                '0%': '#108ee9',
                                '100%': '#87d068',
                              }}
                              strokeWidth={25}
                              style={{ 
                                width: '100%',
                                border: 'none',
                                outline: 'none',
                                marginRight: '0'
                              }}
                            />
                            <span style={{ 
                              position: 'absolute',
                              left: '30%',
                              top: '60%',
                              transform: 'translate(-50%, -50%)',
                              color: 'white',
                              fontSize: '16px',
                              fontWeight: 'bold',
                              textShadow: '1px 1px 2px rgba(0,0,0,0.5)',
                              zIndex: 1
                            }}>
                              {`${totalProgress}%`}
                            </span>
                          </div>
                          <Button 
                            type="text"
                            icon={<CloseOutlined />}
                            onClick={handleCancel}
                            style={{ 
                              display: totalProgress === 100 ? 'none' : 'block',
                              padding: '0',
                              position: 'relative',
                              left: '2px',
                              top: '5px',
                              width: '24px',
                              height: '24px',
                              alignItems: 'center',
                              justifyContent: 'center',
                              borderRadius: '4px',
                              '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.05)',
                              },
                            }}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="right-button-group">
                  <Tooltip
                    title={t('history.layout.menuTitle')}
                    overlayClassName="history-tooltip"
                    placement="top"
                    mouseEnterDelay={0.1}
                    mouseLeaveDelay={0.1}
                  >
                    <Dropdown
                      menu={{ items: layoutMenuItems }}
                      placement="bottomRight"
                      trigger={['click']}
                      destroyPopupOnHide={true}
                    >
                      <div className={`icon-button ${layoutType}`}>
                        <BorderHorizontalOutlined className="fz-42" />
                      </div>
                    </Dropdown>
                  </Tooltip>

                  <Tooltip
                    title={t('history.actionsTitle')}
                    overlayClassName="history-tooltip"
                    placement="top"
                    mouseEnterDelay={0.1}
                    mouseLeaveDelay={0.1}
                  >
                    <div
                      className="icon-button"
                      onClick={() => setShowDeleteItem(true)}
                    >
                      <AppstoreFilled className="fz-42" />
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="p-16" style={{ marginTop: 0, flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          {layoutType === 'default' ? (
            // 기본 모드일 때는 기존 테이블만 표시
            <div style={{ 
              height: '100%', 
              overflow: 'auto'
            }} className="custom-scrollbar">
              <TableHistory
                data={data}
                tableParams={tableParams}
                onChangePage={onChangePage}
                loading={loading}
                onSelectChange={onSelectChange}
                selectedRowKeys={selectedRowKeys}
                handleChangeName={handleChangeName}
                totalPages={totalPages}
                handleReportClick={handleReportClick}
              />
            </div>
          ) : (
            // 가로 또는 세로 모드일 때는 분할 뷰 표시
            <div
              className={`${styles.splitView} ${layoutType === 'vertical' ? styles.vertical : styles.horizontal}`}
              ref={splitViewRef}
              style={{
                overflowY: layoutType === 'horizontal' ? 'auto' : 'hidden',
                overflowX: 'hidden'
              }}
            >
              <div
                className={`${styles.mainContent} custom-scrollbar`}
                ref={mainContentRef}
                style={{
                  overflow: 'auto',
                  maxHeight: '100%',
                  width: layoutType === 'vertical' ? '50%' : '100%',
                  height: layoutType === 'vertical' ? '100%' : '50%'
                }}
              >
                <div className="custom-scrollbar" style={{
                  height: '100%',
                  overflow: 'auto',
                  width: '100%'
                }}>
                  <TableHistory
                    data={data}
                    tableParams={tableParams}
                    onChangePage={onChangePage}
                    loading={loading}
                    onSelectChange={onSelectChange}
                    selectedRowKeys={selectedRowKeys}
                    handleChangeName={handleChangeName}
                    totalPages={totalPages}
                    handleReportClick={handleReportClick}
                  />
                </div>
              </div>
              
              {layoutType !== 'default' && (
                <>
                  <div 
                    className={styles.resizeHandle}
                    onMouseDown={handleResize}
                    style={{ 
                      cursor: layoutType === 'horizontal' ? 'row-resize' : 'col-resize',
                      width: layoutType === 'horizontal' ? '100%' : '10px',
                      height: layoutType === 'horizontal' ? '10px' : '100%',
                      backgroundColor: '#f0f0f0',
                      border: '1px solid #e0e0e0',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      zIndex: 10
                    }}
                  >
                    <div style={{
                      width: layoutType === 'horizontal' ? '30px' : '4px',
                      height: layoutType === 'horizontal' ? '4px' : '30px',
                      backgroundColor: '#ccc',
                      borderRadius: '2px'
                    }}></div>
                  </div>
                  <div className={`${styles.detailContent} custom-scrollbar`}>
                    <div className={`${styles.iframeContainer} custom-scrollbar`}>
                      {isResizing && (
                        <div style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          zIndex: 999,
                          backgroundColor: 'transparent'
                        }} />
                      )}
                      {selectedRowKeys.length > 0 ? (
                        <iframe 
                          src={`/summary/${selectedRowKeys[0]}`}
                          style={{
                            width: '100%',
                            height: '100%',
                            border: 'none',
                            display: 'block'
                          }}
                          className="custom-scrollbar"
                          title="Summary View"
                        />
                      ) : (
                        <div className={styles.noSelection}>
                          <p><Trans i18nKey="history.splitHint" /></p>
                        </div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
      </div>
      
      <ModalSearch
        openModal={openModal}
        setOpenModal={setOpenModal}
        onChangeSearch={onChangeSearch}
      />
      <ModalDelete
        tableParams={tableParams}
        openModal={showDeleteItem}
        setOpenModal={setShowDeleteItem}
        selectedRows={selectedRows}
        handleDeleteItem={handleDeleteItem}
        openNotificationWithIcon={openNotificationWithIcon}
        isLoading={isLoading}
        username={username}
      />
      <Modal
        open={pageLoading}
        footer={null}
        closable={false}
        centered
        width={300}
      >
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spin size="large" />
          <p style={{ marginTop: '10px' }}>{t('history.loading')}</p>
        </div>
      </Modal>
      <Modal
        open={isLoading}
        footer={null}
        closable={false}
        centered
        width={300}
      >
        <div style={{ textAlign: 'center', padding: '20px' }}>
          <Spin size="large" />
          <p style={{ marginTop: '10px' }}>{t('history.loading')}</p>
        </div>
      </Modal>
    </div>
  );
};

export default History;